var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h4',{attrs:{"id":"tailieTitleText"}},[_vm._v(_vm._s(_vm.$t("match-no-fit-title")))])])],1),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('p',[_vm._v(_vm._s(_vm.$t("match-no-fit-message")))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }